const roles = {
    1: "System Admin",
    2: "Admin",
    3: "Manager",
    4: "Collector",
    5: "User",
    6: "Power User",
}

const customerManagementEditorRoles = [
    1,
    2,
    3,
    6
];

const userManagementRoles = [
    1,
    2,
    3,
]

export default roles;

export {
    customerManagementEditorRoles,
    userManagementRoles
}